module.exports = __webpack_public_path__ + "static/img/addUs_2.c078f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/addUs_2.png
// module id = NX21
// module chunks = 1